import React, { Component } from 'react'
import { connect } from 'react-redux'
import styles from './CaptureVideoImageStyles'
import { Icon, Popup } from 'semantic-ui-react'
import VideoActions from 'Redux/VideoRedux'
import { getVideoImage } from 'Lib/CaptureVideoImage'
import AwsS3Multipart from '@uppy/aws-s3-multipart'
import DebugConfig from 'Config/DebugConfig'
import Uppy from '@uppy/core'

const uppy = Uppy({
  autoProceed: false,
  allowMultipleUploads: true,
  restrictions: {
    maxFileSize: null,
    maxNumberOfFiles: 1,
    minNumberOfFiles: 1,
    allowedFileTypes: ['image/*']
  }
})

uppy.use(AwsS3Multipart, {
  // default is '/s3'
  serverUrl: DebugConfig.isDev ? 'http://localhost:3001' : 'https://api.seekrev.com'
})

class CaptureVideoImage extends Component {

  static defaultProps = {
    onFrameCapture: () => {},
  }

  state = {
    isUploading: false
  }

  componentWillMount () {
    uppy.on('complete', this.onUploadComplete)
  }

  componentWillUnmount () {
    uppy.off('complete', this.onUploadComplete)
    uppy.cancelAll()
  }

  componentDidUpdate () {
    // handle error(updateError) or success(updateData) here.
  }

  onUploadComplete = result => {
    if (result.successful.length === 1) {
      const uploadedFileData = result.successful.map(file => {
        return JSON.stringify({
          // extract key without prefix
          id: file.uploadURL.match(/\/cache\/([^?]+)/)[1],
          storage: 'cache',
          metadata: {
            filename: file.name,
            size: file.data.size,
            mime_type: file.data.type,
          }
        })
      })
      this.setState({isUploading: false})
      this.props.videosUpdateRequest(this.props.videoId, {
        poster: uploadedFileData[0],
      })
    }
    uppy.reset()
  }

  onFrameCapture = () => {
    this.props.onFrameCapture()
    this.setState({isUploading: true})
    if (this.props.videoEl) {
      uppy.addFile({
        name: this.props.title + '.jpg',
        type: 'image/jpeg',
        data: getVideoImage(this.props.videoEl),
        source: 'Local'
      })
      uppy.upload()
    }
  }

  render() {
    return this.state.isUploading ? (
      <div className={styles.loader}><Icon loading name='spinner' /></div>
    ) : (
      <Popup
        content='Set current frame as poster of this video'
        size='mini'
        inverted
        position='top center'
        trigger={
          <div className={styles.component}>
            <Icon
              size='large'
              className={styles.button}
              onClick={this.onFrameCapture}
              name='camera' />
          </div>
        }/>
    )
  }
}

const mapStateToProps = (state) => ({
  updateFetching: state.videos.updateFetching,
  updateData: state.videos.updateData,
  updateError: state.videos.updateError
})

const mapDispatchToProps = (dispatch) => ({
  videosUpdateRequest: (id, updateParams) =>
    dispatch(VideoActions.videosUpdateRequest(id, updateParams))
})

export default connect(mapStateToProps, mapDispatchToProps)(CaptureVideoImage)




// WEBPACK FOOTER //
// ./src/Components/VideoPlayer/CaptureVideoImage/CaptureVideoImage.js